// extracted by mini-css-extract-plugin
module.exports = {"paper":"BaseTable_paper__VmvI1","baseSubTable":"BaseTable_baseSubTable__2IV5k","baseTable":"BaseTable_baseTable__2ViRD"};